import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './TableBasic.css';

// NOTE: This table is designed to replace the existing Table once it can be phased out.

const Table = ({ children, className, ...rest }) => (
  <table className={classNames('table-basic', className)} {...rest} >
    { children }
  </table>
);

Table.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};


export default Table;



// WEBPACK FOOTER //
// ./src/components/TableBasic/TableBasic.jsx